import {types} from './types';

export const setGettatisticsAction = (payload) => {
    return {
        type: types.SET_GET_STATISTICS,
        payload,
      }
}